/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState } from 'react';
import { Headline } from '../../atoms/headline';
import { Button } from '../../atoms/button';
import { useSelector, useDispatch } from 'react-redux';
import './forgot-password.module.css';
import { triggerSendOtp, getErrorStyle, genericError, inputFieldError, handleScrollToTop } from '../../util';
import { ErrorMessage } from '../../atoms/error-message';
import {
  EMAIL_LABEL,
  FORGOT_PASSWORD_TITLE,
  GET_OTP_BUTTON,
  GO_BACK_BUTTON,
  QUILL_EMPTY_STRING,
  UPDATE_FORGOT_PASSWORD,
  UPDATE_SINGLE_SIGN_ON
} from '../../../../../constants';
import get from 'lodash/get';
import { getPath } from '../../../../../utils';

export const ForgotPasswordScreen = ({ mode, isUserLoginPage = false }) => {
  const { forgotPassword = {}, singleSignOn = {} } = useSelector(state => get(state, ['login'], {}));
  const sketchesHost = useSelector(state => get(state, ['qt', 'config', 'sketches-host'], {}));
  const { inputData: ssoInputData = '' } = get(singleSignOn, ['userData'], {});
  const localStorageEmail = global?.localStorage?.getItem('userEmail');
  const { inputData = '' } = get(forgotPassword, ['userData'], {});

  const emailData = inputData || localStorageEmail;
  const [email, setEmail] = useState(!isUserLoginPage ? emailData : ssoInputData);
  const [response, setResponse] = useState(null);
  const [api, setApi] = useState(null);
  const dispatch = useDispatch();
  const loginSetting = useSelector(state => get(state, ['qt', 'config', 'pagebuilder-config', 'login'], {}));
  const whiteListedUrlParams = useSelector(state => get(state, ['qt', 'config', 'pagebuilder-config', 'general', 'others', 'whiteListedUrlParams'], []));
  
  handleScrollToTop();

  const triggerGetOtp = async () => {
    global?.localStorage?.setItem('userEmail', email);
    const otpResponse = await triggerSendOtp({ email, sketchesHost });
    setResponse(otpResponse);
    setApi('send-otp-email');
    if (otpResponse === 200) {
      dispatch({
        type: !isUserLoginPage ? UPDATE_FORGOT_PASSWORD : UPDATE_SINGLE_SIGN_ON,
        payload: {
          currentScreen: 'resetPassword',
          userData: { inputData: email }
        }
      });
    }
  };

  const triggerGetBack = async () => {
    if (!isUserLoginPage) {
      global?.localStorage?.setItem('userEmail', email);
      window.location.href = getPath({
        sketchesHost,
        relativePath: '/sign-in',
        injectCustomParams: true,
        whiteListedUrlParams
      });
    } else {
      dispatch({
        type: UPDATE_SINGLE_SIGN_ON,
        payload: {
          currentScreen: 'signIn',
          userData: { inputData: email }
        }
      });
    }
  };
  const { goBackButton, getOtpButton, emailLabel, pageTitle } = get(
    loginSetting,
    ['forgot-password', 'rows', 0, 'config'],
    {}
  );
  return (
    <div className={`auth--wrapper ${mode}`}>
      <Headline content={pageTitle && pageTitle !== QUILL_EMPTY_STRING ? pageTitle : FORGOT_PASSWORD_TITLE} />
      <div styleName='input-email' className={getErrorStyle(response, api, mode)}>
        <label for='email'>{emailLabel || EMAIL_LABEL}</label>
        <input
          type='email'
          id='email'
          name='email'
          value={email}
          onChange={event => {
            setResponse(null);
            setApi(null);
            setEmail(event.target.value);
          }}
          required
        />
        {inputFieldError(response, api) ? <ErrorMessage response={response} api={api} mode={mode} /> : <></>}
      </div>
      <Button
        text={getOtpButton || GET_OTP_BUTTON}
        clickHandler={() => triggerGetOtp()}
        disable={!email}
        enableEnterClick={true}
      />
      {genericError(response, api) ? <ErrorMessage response={response} api={api} mode={mode} /> : <></>}
      <div styleName='custom-button' className='auth--text-color'>
        <Button text={goBackButton || GO_BACK_BUTTON} clickHandler={() => triggerGetBack()} />
      </div>
    </div>
  );
};
